import React, { useState, useContext } from "react"
import Axios from "axios"
import DispatchContext from "./DispatchContext"

const HeaderLoggedOut = (props) => {
  const appDispatch = useContext(DispatchContext)

  const [username, setUsername] = useState()
  const [password, setPassword] = useState()
  async function handleSubmit(e) {
    e.preventDefault()
    try {
      const response = await Axios.post("/login", { username, password })
      if (response.data) {
        // alert("enjoy logging in!")
        // localStorage.setItem("teddaaappToken", response.data.token)
        // localStorage.setItem("teddaaappUsername", response.data.username)
        // localStorage.setItem("teddaaappAvatar", response.data.avatar)

        appDispatch({ type: "login", data: response.data })
      } else {
        alert("incorrect username or password")
        console.log(response.data)
        // props.setLoggedIn(true)
      }
    } catch (e) {
      console.log("failed")
    }
  }

  return (
    <form onSubmit={handleSubmit} class="mb-0 pt-2 pt-md-0">
      <div class="row align-items-center">
        <div class="col-md mr-0 pr-md-0 mb-3 mb-md-0">
          <input onChange={(e) => setUsername(e.target.value)} name="username" class="form-control form-control-sm input-dark" type="text" placeholder="Username" autocomplete="off" />
        </div>
        <div class="col-md mr-0 pr-md-0 mb-3 mb-md-0">
          <input onChange={(e) => setPassword(e.target.value)} name="password" class="form-control form-control-sm input-dark" type="password" placeholder="Password" />
        </div>
        <div class="col-md-auto">
          <button class="btn btn-success btn-sm">Sign In</button>
        </div>
      </div>
    </form>
  )
}

export default HeaderLoggedOut
